import { render, staticRenderFns } from "./FicheGlider.vue?vue&type=template&id=60e1d478"
import script from "./FicheGlider.vue?vue&type=script&lang=ts"
export * from "./FicheGlider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports